import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { ArrowLeft, Plus, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const NewDossierV2 = () => {
  const [notes, setNotes] = useState("");
  const [dateInstallation, setDateInstallation] = useState("");
  const [creating, setCreating] = useState(false);
  const navigate = useNavigate();

  const handleCreate = async () => {
    setCreating(true);
    try {
      const response = await axios.post(`${API}/dossiers`, {
        notes,
        date_installation: dateInstallation,
      });
      toast.success("Expediente creado");
      navigate(`/dossier/${response.data.id}`);
    } catch (error) {
      toast.error(
        "Error al crear expediente: " +
          (error.response?.data?.detail || error.message)
      );
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-10">
      <Button
        variant="ghost"
        className="mb-4"
        onClick={() => navigate("/dossiers")}
        data-testid="back-to-dossiers-btn"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Volver a dossiers
      </Button>

      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Nuevo Expediente</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Fecha de instalación (opcional)
            </label>
            <Input
              type="date"
              value={dateInstallation}
              onChange={(e) => setDateInstallation(e.target.value)}
              data-testid="date-installation-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Notas (opcional)
            </label>
            <Textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Notas internas..."
              rows={3}
              data-testid="notes-input"
            />
          </div>

          <Button
            className="w-full"
            onClick={handleCreate}
            disabled={creating}
            data-testid="create-dossier-v2-btn"
          >
            {creating ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Creando...
              </>
            ) : (
              <>
                <Plus className="w-4 h-4 mr-2" />
                Crear Expediente
              </>
            )}
          </Button>

          <p className="text-xs text-slate-400 text-center">
            Podrás subir documentos y extraer datos desde la ficha del expediente.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default NewDossierV2;
